import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { BaseComponent, SelectOption } from '../../../shared';
import { Session } from '../../services/session.service';
import { TranslationService } from '../../services/translation.service';

@Component({
    selector: 'app-language-preference-page',
    template: ` <div>
    <div>
      <p class="heading2">
        {{
          'Select the language you would like to display this site in. You can also update this setting by using the language selector at the bottom of each page.'
            | translation : translationRequest 
        }}
      </p>
    </div>
    <div class="app-pt1 app-pb2">
      <span class="tw-w-full">
        <strong>
          {{
            'please choose your preferred language below.'
              | translation : translationRequest | sentenceCase
          }}
        </strong>
      </span>
    </div>
    <div>
      <form [formGroup]="formGroup">
        <app-select-control
            formControlName="preferredLanguage"
            [formGroup]="formGroup"
            [label]="Language"
            validationControl="Language"
            [options]="availableLanguages"
            [multiple]="false"
            ngDefaultControl
            className="tw-w-full md:tw-w-[25%]"
            [translationNeeded]="false"
          />
      </form>
    </div>
    <div class="btnStyleMob">
      <app-button
        [id]="'saveLanguagePreferences'"
        emphasis="High"
        mat-raised-button
        (click)="onSubmit()"
        (keydown.enter)="onSubmit()"
        [arialabel]="
          'Save language preferences'
        "
        label="Save"
      >
      </app-button>
      <span class="app-button-margin"></span>
      <app-button
        [id]="'cancelLanguagePreferences'"
        mat-raised-button
        emphasis="Low"
        color="whiteButton"
        (click)="onCancel()"
        (keydown.enter)="onCancel()"
        [arialabel]="
          'Cancel language preferences changes'
            | translation : translationRequest
        "
        label="Cancel"
      >
      </app-button>
    </div>
  </div>`,
    styles: [
        `
      ::ng-deep .container {
        margin-top: 8px;
        display: flex;
        flex-direction: column;
      }

      .btnStyleMob {
        display: flex;
        justify-content: flex-end;
      }
    `,
    ],
    standalone: false
})
export class LanguagePreferencePageComponent extends BaseComponent implements OnInit {
  availableLanguages: SelectOption[] = [];
  selectedLanguage = 'en';
  Language = 'Language';

  @Input()
  translationRequest: TranslationRequest;

  formGroup = this.formBuilder.group({
    preferredLanguage: ['', Validators.required],
  });

  constructor(
    public session: Session,
    private translationService: TranslationService,
    private router: Router,
    private formBuilder: FormBuilder
  ) {
    super();
    this.formGroup.setValue({
      preferredLanguage: sessionStorage.getItem('languagepreference')
    });
  }

  async ngOnInit(): Promise<void> {
    await this.getLanguages();

    if(sessionStorage.getItem('languagepreference') == 'fr')
    {
      this.Language = 'language';
    }
  }

  async getLanguages(): Promise<void> {
    try {
      // Use the async method that properly handles the Observable and caching
      await this.translationService.getLanguagesAsync();
      // Now get the languages from the service
      this.availableLanguages = this.translationService.languages();
    } catch (error) {
      console.error('Error loading languages:', error);
      // Fallback to empty array if loading fails
      this.availableLanguages = [];
    }
  }

  async onSubmit(): Promise<void> {
    const selectedLanguage = this.availableLanguages.find(
      (x) => x.value === this.formGroup.controls['preferredLanguage'].value
    );

    this.FeatureLogging('MultiLanguageTranslation', selectedLanguage.value, 'Account settings - Language switch');

    sessionStorage.setItem('languagepreference', selectedLanguage.value);
    await this.translationService.setDefaultLanguage(selectedLanguage.value);
    await this.session.setLanguagePreferenceForUser(selectedLanguage.value);

    window.location.reload();
  }

  onCancel(): void {
    this.router.navigate(['/']);
  }
}
